// extracted by mini-css-extract-plugin
export var wordContainer = "_pe-0";